// (function () {
//     'use strict';

//     angular.module("imApp").factory("p2ReleaseNoteService", ['$ihttp', function ($ihttp) {
//         let service = {
//             getReleaseNoteSettings: function (parms) {
//                 return $ihttp.post({
//                     method: 225,
//                     parameters: parms || {}
//                 });
//             },
//             listReleaseNotes: function (parms) {
//                 return $ihttp.post({
//                     method: 221,
//                     parameters: parms || {}
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
